<template>
  <div id="bizIndex" class="word-break-keep-all">
    <section id="hero">
      <div class="container">
        <p>비즈니스 성공을 위한 핵심 플랫폼</p>
        <h1 class="title">간단하고 쉬운<br/>태양광 검토 및 경제성 분석</h1>
        <div class="introduce-service">
          <a href="https://biz.haezoom.com/media/biz/biz_brochure.pdf" target="_blank" class="hz-btn-default hz-btn-lg">브로셔 보기</a>
          <a href="https://youtu.be/1ClS9Yqvmww" target="_blank" class="hz-btn-default hz-btn-lg">소개영상 보기</a>
        </div>
      </div>
    </section>
    <section id="search" class="mobile-gutter">
      <div class="container">
        <div class="row">
          <div class="col-lg-offset-3 col-lg-6 col-md-offset-2  col-md-8 padding-0">
            <div v-if="!user.id" style="position: absolute; width: 100%; height: 100%; z-index: 5;" @click="showLoginModal"></div>
            <index-input-address ref="inputAddress" v-model="address"></index-input-address>
            <button type="button" v-show="address.length === 0" class="btn-search" @click="search">검색하기</button>
            <button type="button" v-show="address.length > 1" class="btn-search" @click="review">검토하기</button>
            <div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="banner" v-if="bannerList.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-md-push-1 col-md-10">
            <carousel :itemList="bannerList"
                      :options="{interval: 10000}"
                      :showControl="showBannerControl"
                      :showIndicator="bannerList.length > 1"
                      @linkEvent="toLink"
            >
            </carousel>
          </div>
        </div>
      </div>
    </section>
    <section id="intro">
      <div class="container">
        <div class="card">
          <h2>원클릭 사업검토로 <br>심플하고 정확하게!</h2>
          <p class="desc">다양한 사이트를 방문해야 하는 번거로움을 제거하고 <br>고객에게 전송까지 한 번에 가능합니다.</p>
          <router-link to="/oneclick" class="link">원클릭 사업검토 바로가기<span class="glyphicon glyphicon-arrow-right"></span></router-link>
          <img src="~@/assets/img/index/index-intro-01@2x.png" class="img-responsive hidden-xs hidden-sm" alt="">
          <img src="~@/assets/img/index/index-intro-xs-01@2x.png" class="img-responsive hidden-lg hidden-md" alt="">
        </div>
        <div class="card">
          <h2>95% 정확성의 보고서를 <br>회원사 맞춤형으로!</h2>
          <p class="desc">정확한 데이터를 기반으로 한  PDF 파일 보고서로 고객에게 신뢰를 높이고, <br>로고 및 회원사에 맞춘 커스텀 서비스를 제공합니다.</p>
          <router-link to="/extend" class="link">프리미엄 보고서 바로가기<span class="glyphicon glyphicon-arrow-right"></span></router-link>
          <img src="~@/assets/img/index/index-intro-02@2x.png" class="img-responsive hidden-sm hidden-xs" alt="">
          <img src="~@/assets/img/index/index-intro-xs-02@2x.png" class="img-responsive hidden-lg hidden-md" alt="">
        </div>
        <div class="card">
          <h2>멤버십 특가로 <br class="hidden-xs">다양한 패널, 인버터 가격 확인!</h2>
          <p class="desc">전 세계 모든 제조사 제품 문의 가능, <br>비즈해줌 고객사에게만 제공하는 멤버십 최저가의 패널과 인버터를 만날 수 있습니다.</p>
          <router-link to="/product" class="link">패널 인버터 견적 바로가기<span class="glyphicon glyphicon-arrow-right"></span></router-link>
          <img src="~@/assets/img/index/index-intro-03@2x.png" class="img-responsive hidden-sm hidden-xs" alt="">
          <img src="~@/assets/img/index/index-intro-xs-03@2x.png" class="img-responsive hidden-lg hidden-md" alt="">
        </div>
      </div>
    </section>
    <section id="info" class="mobile-gutter" v-if="priceDataState === 'SC'">
      <div class="container">
        <h4>
          오늘의 SMP, REC 확인하기<span class="sub-text">최근 업데이트 {{ priceUpdateDate }}</span>
          <a href="#moreInfo" id="moreBtn" class="hidden-sm hidden-xs" data-toggle="collapse">
            {{ moreBtnText }} <i :class="['glyphicon', {'glyphicon-chevron-down': !moreInfoActive}, {'glyphicon-chevron-up': moreInfoActive}]"></i>
          </a>
        </h4>
        <ul class="row margin-bottom-24">
          <li class="col-md-4">
            <h5 class="type">
              SMP
              <span class="sub-text">평균가</span>
              <div class="tab pull-right" v-model="smpType">
                <a href="javascript:void(0);" :class="{'active': smpType === 'day'}" @click="smpType = 'day'">최근 1달</a>
                <a href="javascript:void(0);" :class="{'active': smpType === 'month'}" @click="smpType = 'month'">최근 1년</a>
              </div>
            </h5>
            <div class="price">
              <div class="name">육지</div>
              <div class="value">{{ smpData[smpType].smp_land_price_avg | intcomma }} 원<em class="unit">/kWh</em></div>
            </div>
            <div class="price">
              <div class="name">제주</div>
              <div class="value">{{ smpData[smpType].smp_jeju_price_avg | intcomma }} 원<em class="unit">/kWh</em></div>
            </div>
          </li>
          <li class="col-md-4">
            <h5 class="type">REC 현물시장<span class="sub-text margin-top-8 pull-right">최근 1년 평균가</span></h5>
            <div class="price">
              <div class="name">육지</div>
              <div class="value">{{ recData.rec_land_price_avg | intcomma }} 원<em class="unit">/MWh</em></div>
            </div>
            <div class="price">
              <div class="name">제주</div>
              <div class="value">{{ recData.rec_jeju_price_avg | intcomma }} 원<em class="unit">/MWh</em></div>
            </div>
          </li>
          <li class="col-md-4">
            <h5 class="type">REC 계약시장
              <span class="sub-text">SMP+REC</span>
              <span class="sub-text margin-top-8 pull-right">{{ recContractData.rec_cont_period }}</span></h5>
            <div class="price">
              <div class="name">육지</div>
              <div class="value">{{ recContractData.rec_cont_land_price_avg | intcomma }} 원<em class="unit">/MWh</em></div>
            </div>
            <div class="price">
              <div class="name">제주</div>
              <div class="value">{{ recContractData.rec_cont_jeju_price_avg | intcomma }} 원<em class="unit">/MWh</em></div>
            </div>
          </li>
        </ul>
        <ul id="moreInfo" class="row collapse in hidden-sm hidden-xs">
          <li class="col-md-4">
            <div class="line"></div>
            <smp-chart :active="moreInfoActive" :value="smpData[smpType]" :type="smpType"></smp-chart>
          </li>
          <li class="col-md-4">
            <div class="line"></div>
            <rec-chart :value="recData"></rec-chart>
          </li>
          <li class="col-md-4">
            <div class="line"></div>
            <rec-contract-chart :value="recContractData"></rec-contract-chart>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
  'use strict'
  import IndexInputAddress from '@/components/IndexInputAddress'
  import Carousel from '@/components/Carousel'
  import SmpChart from '@/components/chart/SmpChart'
  import RecContractChart from '@/components/chart/RecContractChart'
  import RecChart from '@/components/chart/RecChart'
  import api from '@/api/index'
  import eventHub from '@/shared/EventHub'
  import { mapGetters } from 'vuex'

  export default {
    name: 'index',
    components: {
      IndexInputAddress,
      Carousel,
      SmpChart,
      RecContractChart,
      RecChart
    },
    data () {
      return {
        moreInfoActive: false,
        windowWidth: 0,
        address: '',
        bannerList: [],
        priceDataState: '',
        priceUpdateDate: '',
        smpType: 'day',
        smpData: {},
        recData: {},
        recContractData: {}
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        noticeList: 'noticeList'
      }),
      moreBtnText () {
        return this.moreInfoActive ? '닫기' : '더보기'
      },
      showBannerControl () {
        const isNotSingleBanner = this.bannerList.length > 1
        const isNotMobile = this.windowWidth > 767

        return isNotSingleBanner > 0 && isNotMobile
      }
    },
    watch: {
      'user': {
        handler: function () {
          // 로그인한 유저에 ID가 있고, 그 유저가 3dsolarmap일 경우 원클릭사업검토 페이지로 이동한다.
          if (this.user.id && (this.user.username === '3dsolarmap')) {
            if (this.$route.query.setAddr) {
              // 3D햇빛지도로부터 넘어왔다면 총 설치용량도 함께 넘어와야 한다. 넘어온 값을 로컬스토리지에 저장하여 필요할 때 꺼내쓴다.
              localStorage.setItem('totalCapacity', this.$route.query.totalCapacity)
              this.$router.push({name: 'oneclickNewDetail', params: { address: this.$route.query.setAddr, buildingID: this.$route.query.buildingID }})
            }
          }
        }
      }
    },
    methods: {
      showLoginModal () {
        // Main.vue로 이벤트 전달
        eventHub.$emit('showLoginModal')
      },
      getBanner () {
        // 인덱스 배너 목록을 불러온다.
        api.getBanner('index', response => {
          if (response.error) {
            console.log('can`t get Index Banner!', response)
          } else {
            this.bannerList = response
          }
        })
      },
      getPriceInfo () {
        // SMP, REC 정보를 요청한다.
        api.getPriceInfo(response => {
          if (response.error) {
            console.log('get Price Info fail!', response)
          } else {
            // 요청 데이터가 정상적으로 들어왔을 경우에만 실행
            if (response.code === 'SC') {
              const result = response.result
              const recContract = result.rec_contract
              const recLength = recContract.rec_cont_jeju_period.length

              // REC 계약시장 가격에 기준시기를 가공하여 반환한다.
              const recContPeriod = (() => {
                const lastPeriod = recContract.rec_cont_jeju_period[recLength - 1]
                const year = lastPeriod.substring(0, 4)
                const half = parseInt(lastPeriod.substring(4, 2)) > 6 ? '하반기' : '상반기'

                return `${year}년 ${half} 평균가`
              })()

              // 데이터 업데이트 일시
              this.priceUpdateDate = result.update_date

              // SMP
              this.smpData = {
                day: result.smp_days,
                month: result.smp_months
              }

              // REC 계약시장
              this.recContractData = Object.assign(recContract, {
                rec_cont_period: recContPeriod,
                rec_cont_land_price_avg: recContract.rec_cont_land_price[recLength - 1],
                rec_cont_jeju_price_avg: recContract.rec_cont_jeju_price[recLength - 1]
              })

              // REC 현물시장
              this.recData = result.rec

              // 데이터 요청 상태 초기화
              this.priceDataState = response.code

              this.$nextTick(() => {
                // C3 차트 초기화 후 Collapse를 닫는다.
                $('#moreInfo').collapse('hide')

                // SMP, REC 가격정보 더보기, 닫기 버튼 이벤트 추가
                $('#moreInfo').on('show.bs.collapse', () => { this.moreInfoActive = true })
                $('#moreInfo').on('hide.bs.collapse', () => { this.moreInfoActive = false })
              })
            }
          }
        })
      },
      search () {
        // 입력필드에 입력된 주소지에 상세정보를 검색한다.
        this.$refs.inputAddress.onSearch()
      },
      review () {
        // 검색 된 주소목록이 있을 경우, 파라미터에 주소정보를 담아 원클릭보고서 페이지로 이동
        const address = this.address
        if (address) {
          this.$router.push({name: 'oneclickNew', params: { address: address }})
        }
      },
      onResize () {
        this.windowWidth = window.innerWidth
      },
      toLink (data) {
        if (data.new_tab) {
          window.open(data.link, '_blank')
        } else {
          this.$router.push({path: data.link})
        }
      }
    },
    created () {
      this.getBanner()
      this.getPriceInfo()
      this.onResize()
    },
    mounted () {
      window.addEventListener('resize', this.onResize)
    },
    beforeDestroy () {
      kendo.destroy(document.body)
      window.removeEventListener('resize', this.onResize)
    }
  }
</script>

<style lang="scss">
  @import '~@/assets/css/components/chart';
</style>

<style lang="scss" scoped>
  #bizIndex {
    #hero {
      position: relative;
      min-height: 439px;
      background-image:  url("~@/assets/img/bg-index-hero.jpg");
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;

      @media (max-width: $screen-xs-max) {
        min-height: 406px;
        background-image: url("../assets/img/bg-index-hero-xs.jpg");
      }

      .container {
        padding: 130px 16px 0;

        @media (max-width: $screen-xs-max) {
          padding: 77px 16px 0;
          text-align: center;
        }
      }

      .title {
        margin: 0 0 40px;
        font-size: 48px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: -2.9px;
        color: $hzc-white;

        @media (max-width: $screen-xs-max) {
          font-size: 32px;
        }
      }

      p {
        margin: 0 0 16px;
        font-size: 20px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: -0.9px;
        color: #88e99c;

        @media (max-width: $screen-xs-max) {
          font-size: 16px;
        }
      }

      a {
        width: 167px;
        padding: 14px 16px;

        &:first-child {
          margin: 0 8px 0 0;
        }

        &:last-child {
          margin: 0 0 0 8px;
        }

        @media (max-width: $screen-xs-max) {
          width: 144px;
        }
      }
    }

    #search {
      padding: 32px 0;
      overflow: hidden;
      background-color: #f3f4f8;

      .btn-search {
        width: 163px;
        height: 48px;
        margin-left: 4px;
        border-radius: 4px;
        box-shadow: 0 1px 1px 0 rgba(45, 55, 77, 0.3);
        border: solid 1px #2d374d;
        background-color: #2d374d;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: center;
        color: $hzc-white;

        &:focus {
          outline: none;
        }

        &:hover {
          background-color: darken(#2d374d, 10%);
        }
      }

      @media(max-width: 767px) {
        .btn-search {
          width: 100%;
          margin: 8px 0 0 0;
        }
      }
    }

    #banner {
      .container {
        padding: 48px 0;

        @media (max-width: 767px) {
          padding: 32px 0;

          .col-md-10 {
            padding: 0;
          }
        }
      }
    }

    #intro {
      padding: 96px 0 10px;
      text-align: center;

      h2 {
        margin: 0 0 20px;
        font-size: 32px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: -1.6px;
        text-align: center;
        color: #2e3134;
      }

      .card {
        margin-bottom: 100px;
      }

      .desc {
        margin-bottom: 24px;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: -0.8px;
        text-align: center;
        color: #2e3134;
      }

      .link {
        display: block;
        margin-bottom: 24px;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: -1.3px;
        text-decoration: none;
        color: #9b88e9;

        .glyphicon-arrow-right {
          margin-left: 8px;
          font-size: 14px;
          color: $hzc-gray-04;
        }
      }

      img {
        max-height: 100%;
      }

      @media (max-width: 991px) {
        img {
          max-width: 343px;
          width: 100%;
          margin: auto;
        }
      }

      @media (max-width: 767px) {
        padding: 80px 16px 0;
      }
    }

    #info {
      padding: 52px 0 48px;
      border-top: 1px solid $hzc-gray-02;

      ul, li {
        list-style: none;
      }

      h4 {
        margin: 0 0 35px;
        font-size: 20px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: -0.9px;
        color: #2e3134;
      }

      h4 a {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.71;
        letter-spacing: -0.7px;
        color: #54595f;
        float: right;
        text-decoration: none;

        i {
          margin-left: 12px;
          font-size: 12px;
          color: #343a40;
        }
      }

      .tab {
        a {
          margin: 0;
          padding: 5px 24px;
          font-size: 15px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.07;
          letter-spacing: normal;
          text-align: center;
          color: #495057;
          border-radius: 20.5px;
          background-color: $hzc-white;
          cursor: pointer;
          text-decoration: none;

          &.active, &:hover {
            background-color: #f5f2fc;
            color: #7c61e8;
          }

          @media (max-width: 767px) {
            padding: 5px 16px;
          }
        }
      }

      .sub-text {
        margin: 0 16px;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: -0.8px;
      }

      h4 .sub-text {
        color: $hzc-gray-05;

        @media (max-width: 767px) {
          margin: 8px 0 0 0;
          display: block;
        }
      }

      h5 .sub-text {
        color: $hzc-gray-07;
      }

      .type {
        min-height: 32px;
        margin: 0;
        padding-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: -1.3px;
        border-bottom: 1px solid $hzc-gray-02;
      }

      .price {
        padding: 12px 0;
        overflow: hidden;

        .name, .value {
          width: 50%;
          float: left;
        }

        .name {
          padding-left: 16px;
          font-size: 14px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.71;
          letter-spacing: -0.7px;
          color: #54595f;
        }

        .value {
          padding-right: 16px;
          font-size: 16px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.5;
          letter-spacing: -0.8px;
          text-align: right;
          color: #2e3134;

          >.unit {
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            color: $hzc-gray-05;
          }
        }
      }

      @media (max-width: 991px) {
        padding: 24px 16px;

        li {
          margin-bottom: 24px;
        }
      }
    }

    #moreInfo {
      .line {
        border-bottom: 1px solid $hzc-gray-02;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue